import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Radio, RadioGroup } from '@wartek-id/radio'
import { Text } from '@wartek-id/text-v1'

import type { HTMLAttributes } from 'react'
import type { UnorPegawai } from 'types/kinerja'

export interface PanelListItemProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  value: string
  testId?: string
}

function PanelListItem({
  label,
  value,
  testId,
  className,
  ...props
}: PanelListItemProps) {
  return (
    <div className={clsx('flex gap-2', className)} {...props}>
      <Text variant="body" className="mb-1 w-48">
        {label}
      </Text>
      <Text variant="body-bold">:</Text>
      <Text data-testid={testId} variant="body-bold">
        {value}
      </Text>
    </div>
  )
}
interface UnorCardProps {
  data: UnorPegawai
  isSatuanPendidikanIndukCorrect?: string | null
  isAtasanCorrect?: string | null
  onAtasanChanged?: (value: string) => void
  onSatuanPendidikanIndukChanged?: (value: string) => void
}

export function UnorSatuanPendidikanCard({
  data,
  isSatuanPendidikanIndukCorrect,
  onSatuanPendidikanIndukChanged,
}: UnorCardProps) {
  return (
    <div
      data-testid="unor-satuan-pendidikan"
      className="max-w-[650px] rounded border border-[color:var(--color-border-subdued)] p-4 flex flex-col gap-4"
    >
      <div className="flex items-center gap-3">
        <Icon>school_outlined</Icon>
        <Text variant="heading-md">Data Satuan Pendidikan Induk</Text>
      </div>

      <div className="bg-[color:var(--color-surface-subdued)] p-3 rounded flex flex-col gap-3">
        <PanelListItem label="Nama Unit Kerja" value={data.satuanPendidikan} />
        <PanelListItem label="Unit Kerja ID" value={data.unorIdPegawai} />
      </div>

      <div>
        <div className="flex gap-3">
          <Text variant="body-bold" className="flex-1">
            Apa Data Satuan Pendidikan Induk benar?
          </Text>

          <Button
            as="a"
            href="https://support-siasn.bkn.go.id/"
            variant="ghost"
            className="flex items-center text-blue-70"
            target="_blank"
          >
            <Icon color="inherit" fontSize="sm">
              help
            </Icon>
            Cek data di e-Kinerja
          </Button>
        </div>
        <RadioGroup
          name="satuanPendidikanInduk"
          className="flex flex-col gap-3 mt-3"
          value={isSatuanPendidikanIndukCorrect}
          onChange={(e) => onSatuanPendidikanIndukChanged(e)}
        >
          <Radio value="true">Ya, data benar</Radio>
          <Radio value="false">Tidak, data salah</Radio>
        </RadioGroup>
      </div>
    </div>
  )
}

export function UnorAtasanCard({
  data,
  isAtasanCorrect,
  onAtasanChanged,
}: UnorCardProps) {
  const hasAtasan = !!data.namaAtasan

  return (
    <div
      data-testid="unor-atasan"
      className="max-w-[650px] rounded border border-[color:var(--color-border-subdued)] p-4 flex flex-col gap-4"
    >
      <div className="flex items-center gap-3">
        <Icon>person_search_outlined</Icon>
        <Text variant="heading-md">Data Atasan</Text>
      </div>

      <div className="bg-[color:var(--color-surface-subdued)] p-3 rounded flex flex-col gap-3">
        {hasAtasan ? (
          <>
            <PanelListItem label="Nama" value={data.namaAtasan} />
            <PanelListItem label="NIP" value={data.nipAtasan} />
            <PanelListItem label="Status" value={data.statusAtasan} />
          </>
        ) : (
          <Text>Tidak ada data.</Text>
        )}
      </div>

      <div>
        <Text variant="body-bold" className="flex-1">
          Apa Data Atasan benar?
        </Text>
        <RadioGroup
          name="atasan"
          className="flex flex-col gap-3 mt-3"
          value={isAtasanCorrect}
          onChange={(e) => onAtasanChanged(e)}
        >
          <Radio value="true">Ya, data benar</Radio>
          <Radio value="false">Tidak, data salah</Radio>
        </RadioGroup>
      </div>
    </div>
  )
}
